import { RootStore } from "./rootStore";
import { observable, action, runInAction, makeAutoObservable } from "mobx";
import { IData, IGraphicData, IDataSales } from "../models/dashboard";
import agent from "../api/agent";
import { IList } from "../models/listOfValours";
import { getDashboardLastUpdate } from "../util/dateOptions";
import { history } from "../..";
import { showError } from "../util/errorTypeEnumsOptions";

export default class DashboarStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }
  @observable loadDash = false;
  @observable lastUpdate = getDashboardLastUpdate();
  @observable loadAcceptDian = false;
  @observable loadRejectDian = false;
  @observable loadCountAllSuccess = false;
  @observable valueFilterAccept = 1;
  @observable valueFilterReject = 1;
  @observable acceptDian: IData[] = [];
  @observable rejectDian: IData[] = [];
  @observable sales: IDataSales[] = [];
  @observable countAcceptDian: number = 0;
  @observable countRejectDian: number = 0;
  @observable countAllSuccess: number = 0;
  @observable salesFilterOptions: IList[] = [];
  @observable valueSalesFilter = new Date().getFullYear();

  // Payroll observables
  @observable loadAcceptDianPayrolls = false;
  @observable loadRejectDianPayrolls = false;
  @observable loadCountAllSuccessPayrolls = false;
  @observable valueFilterAcceptPayrolls = 1;
  @observable valueFilterRejectPayrolls = 1;
  @observable acceptDianPayrolls: IData[] = [];
  @observable rejectDianPayrolls: IData[] = [];
  @observable salesPayrolls: IDataSales[] = [];
  @observable countAcceptDianPayrolls: number = 0;
  @observable countRejectDianPayrolls: number = 0;
  @observable countAllSuccessPayrolls: number = 0;
  @observable salesFilterOptionsPayrolls: IList[] = [];
  @observable valueSalesFilterPayrolls = new Date().getFullYear();

  @action getDash = async () => {
    if (!this.loadDash) {
      this.update();
    }
  };

  @action detailReject = () => {
    let currentDate = new Date();
    let from;
    let to;
    let dif;
    switch (this.valueFilterReject) {
      case 1:
        from = new Date(currentDate.getFullYear(), currentDate.getMonth());
        to = currentDate;
        break;
      case 2:
        from = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1);
        to = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
        break;
      case 3:
        dif =
          currentDate.getDate() -
          currentDate.getDay() +
          (currentDate.getDay() === 0 ? -7 : 1);
        currentDate.setDate(dif);
        from = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate()
        );
        to = currentDate;
        break;
      case 4:
        dif =
          currentDate.getDate() -
          currentDate.getDay() +
          (currentDate.getDay() === 0 ? -7 : 1);
        currentDate.setDate(dif);
        from = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate() - 7
        );
        to = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate() - 1
        );
        break;
      case 5:
        from = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate(),
          0
        );
        to = currentDate;
        break;
    }
    this.rootStore.trackDocumentStore.setDetailReject(from, to);
    history.push("/home/TrackingDocuments");
  };

  @action update = async () => {
    this.filterSwitch(this.valueFilterReject, false);
    this.filterSwitch(this.valueFilterAccept, true);
    this.getCountAllSuccessDocuments();
    this.getGraphDataYearSuccessDocuments(this.valueSalesFilter);
    // Payroll updates
    this.filterSwitchPayrolls(this.valueFilterRejectPayrolls, false);
    this.filterSwitchPayrolls(this.valueFilterAcceptPayrolls, true);
    this.getCountAllSuccessPayrolls();
    this.getGraphDataYearSuccessPayrolls(this.valueSalesFilterPayrolls);
    this.lastUpdate = getDashboardLastUpdate();
    this.loadDash = true;
  };

  @action filterSwitch = async (value: any, isValid: boolean) => {
    if (isValid) {
      this.valueFilterAccept = value;
      this.loadAcceptDian = false;
    } else {
      this.valueFilterReject = value;
      this.loadRejectDian = false;
    }
    switch (value) {
      case 1:
        this.getCurrentMonthData(isValid);
        break;
      case 2:
        this.getLastMonthData(isValid);
        break;
      case 3:
        this.getCurrentWeekData(isValid);
        break;
      case 4:
        this.getLastWeekData(isValid);
        break;
      case 5:
        this.getCurrentDayData(isValid);
        break;
    }
  };

  @action setData = (data: IGraphicData[], isValid: boolean) => {
    runInAction(() => {
      if (isValid) {
        this.acceptDian = [];
        this.countAcceptDian = 0;
        data.map((d) => {
          this.countAcceptDian = this.countAcceptDian + d.count;

          this.acceptDian.push({
            name: d.documentType,
            value: d.count,
          });
        });
      } else {
        this.rejectDian = [];
        this.countRejectDian = 0;
        data.map((d) => {
          this.countRejectDian = this.countRejectDian + d.count;

          this.rejectDian.push({
            name: d.documentType,
            value: d.count,
          });
        });
      }
    });
    if (isValid) {
      this.loadAcceptDian = true;
    } else {
      this.loadRejectDian = true;
    }
  };

  @action getCurrentWeekData = async (isValid: boolean) => {
    try {
      const data = await agent.Dashboard.getCurrentWeekData(isValid);
      this.setData(data, isValid);
    } catch (error) {
      showError(error);
    }
  };

  @action getLastWeekData = async (isValid: boolean) => {
    try {
      const data = await agent.Dashboard.getLastWeekData(isValid);
      this.setData(data, isValid);
    } catch (error) {
      showError(error);
    }
  };

  @action getCurrentMonthData = async (isValid: boolean) => {
    try {
      const data = await agent.Dashboard.getCurrentMonthData(isValid);
      this.setData(data, isValid);
    } catch (error) {
      showError(error);
    }
  };

  @action getLastMonthData = async (isValid: boolean) => {
    try {
      const data = await agent.Dashboard.getLastMonthData(isValid);
      this.setData(data, isValid);
    } catch (error) {
      showError(error);
    }
  };

  @action getCurrentDayData = async (isValid: boolean) => {
    try {
      const data = await agent.Dashboard.getCurrentDayData(isValid);
      this.setData(data, isValid);
    } catch (error) {
      showError(error);
    }
  };

  @action getCountAllSuccessDocuments = async () => {
    try {
      const count = await agent.Dashboard.getCountAllSuccessDocuments();
      runInAction(() => {
        this.countAllSuccess = count;
        this.loadCountAllSuccess = true;
      });
    } catch (error) {
      showError(error);
    }
  };

  @action getGraphDataYearSuccessDocuments = async (year: any) => {
    try {
      const sales = await agent.Dashboard.getGraphDataYearSuccessDocuments(
        year
      );
      runInAction(() => {
        this.sales = sales;
        this.valueSalesFilter = year;
      });
    } catch (error) {
      showError(error);
    }
  };

  @action getFirstYearOfBilling = async () => {
    if (this.salesFilterOptions.length < 1) {
      try {
        const lastYear = await agent.Dashboard.getFirstYearOfBilling();
        const currentYear = new Date().getFullYear();
        let year = currentYear;
        runInAction(() => {
          this.salesFilterOptions = [];
          while (year >= lastYear) {
            this.salesFilterOptions.push({
              key: `${year}`,
              text: `${year}`,
              value: year,
            });
            year--;
          }
        });
      } catch (error) {
        showError(error);
      }
    }
  };

  // Payroll methods
  @action filterSwitchPayrolls = async (value: any, isValid: boolean) => {
    if (isValid) {
      this.valueFilterAcceptPayrolls = value;
      this.loadAcceptDianPayrolls = false;
    } else {
      this.valueFilterRejectPayrolls = value;
      this.loadRejectDianPayrolls = false;
    }
    switch (value) {
      case 1:
        this.getCurrentMonthDataPayrolls(isValid);
        break;
      case 2:
        this.getLastMonthDataPayrolls(isValid);
        break;
      case 3:
        this.getCurrentWeekDataPayrolls(isValid);
        break;
      case 4:
        this.getLastWeekDataPayrolls(isValid);
        break;
      case 5:
        this.getCurrentDayDataPayrolls(isValid);
        break;
      default:
        break;
    }
  };

  @action setDataPayrolls = (data: IGraphicData[], isValid: boolean) => {
    runInAction(() => {
      if (isValid) {
        this.acceptDianPayrolls = [];
        this.countAcceptDianPayrolls = 0;
        data.forEach((d) => {
          this.countAcceptDianPayrolls = this.countAcceptDianPayrolls + d.count;
          this.acceptDianPayrolls.push({
            name: d.documentType,
            value: d.count,
          });
        });
      } else {
        this.rejectDianPayrolls = [];
        this.countRejectDianPayrolls = 0;
        data.forEach((d) => {
          this.countRejectDianPayrolls = this.countRejectDianPayrolls + d.count;
          this.rejectDianPayrolls.push({
            name: d.documentType,
            value: d.count,
          });
        });
      }
    });
    if (isValid) {
      this.loadAcceptDianPayrolls = true;
    } else {
      this.loadRejectDianPayrolls = true;
    }
  };

  @action getCurrentWeekDataPayrolls = async (isValid: boolean) => {
    try {
      const data = await agent.DashboardPayroll.getCurrentWeekData(isValid);
      this.setDataPayrolls(data, isValid);
    } catch (error) {
      showError(error);
    }
  };

  @action getLastWeekDataPayrolls = async (isValid: boolean) => {
    try {
      const data = await agent.DashboardPayroll.getLastWeekData(isValid);
      this.setDataPayrolls(data, isValid);
    } catch (error) {
      showError(error);
    }
  };

  @action getCurrentMonthDataPayrolls = async (isValid: boolean) => {
    try {
      const data = await agent.DashboardPayroll.getCurrentMonthData(isValid);
      this.setDataPayrolls(data, isValid);
    } catch (error) {
      showError(error);
    }
  };

  @action getLastMonthDataPayrolls = async (isValid: boolean) => {
    try {
      const data = await agent.DashboardPayroll.getLastMonthData(isValid);
      this.setDataPayrolls(data, isValid);
    } catch (error) {
      showError(error);
    }
  };

  @action getCurrentDayDataPayrolls = async (isValid: boolean) => {
    try {
      const data = await agent.DashboardPayroll.getCurrentDayData(isValid);
      this.setDataPayrolls(data, isValid);
    } catch (error) {
      showError(error);
    }
  };

  @action getCountAllSuccessPayrolls = async () => {
    try {
      const count = await agent.DashboardPayroll.getCountAllSuccessPayrolls();
      runInAction(() => {
        this.countAllSuccessPayrolls = count;
        this.loadCountAllSuccessPayrolls = true;
      });
    } catch (error) {
      showError(error);
    }
  };

  @action getGraphDataYearSuccessPayrolls = async (year: any) => {
    try {
      const sales = await agent.DashboardPayroll.getGraphDataYearSuccessPayrolls(year);
      runInAction(() => {
        this.salesPayrolls = sales;
        this.valueSalesFilterPayrolls = year;
      });
    } catch (error) {
      showError(error);
    }
  };

  @action getFirstYearOfBillingPayrolls = async () => {
    if (this.salesFilterOptionsPayrolls.length < 1) {
      try {
        const lastYear = await agent.DashboardPayroll.getFirstYearOfBilling();
        const currentYear = new Date().getFullYear();
        let year = currentYear;
        runInAction(() => {
          this.salesFilterOptionsPayrolls = [];
          while (year >= lastYear) {
            this.salesFilterOptionsPayrolls.push({
              key: `${year}`,
              text: `${year}`,
              value: year,
            });
            year--;
          }
        });
      } catch (error) {
        showError(error);
      }
    }
  };
}
